export const getInitialState = (): any => ({
  downloadData: '',
  downloadStatus: 0
});
